function pluralize(singularName, pluralName, count, concat) {
  if (!count || count <= 0) return '';
  return `${concat ? ', ' : ''}${count} ${count === 1 ? singularName : pluralName}`;
}
/** @public */
function useTravelerLabel({
  adults,
  children,
  lapInfants,
  rooms
}) {
  const adultLabel = pluralize('Adult', 'Adults', adults, false);
  const childLabel = pluralize('Child', 'Children', children, true);
  const infantLabel = pluralize('Infant', 'Infants', lapInfants, true);
  const roomLabel = pluralize('Room', 'Rooms', rooms, true);
  let label = adultLabel;
  label += childLabel;
  label += infantLabel;
  label += roomLabel;
  const twoTypesOfChildren = children > 0 && lapInfants > 0;
  const travelerCount = adults + children;
  const travelerLabel = `${travelerCount} Travelers` + infantLabel + roomLabel;
  return twoTypesOfChildren ? travelerLabel : label;
}
export default useTravelerLabel;